<div class="col-sm-12 no-padding animated fadeIn">
    <h3>Listagem</h3>
    <hr>

    <div class="col-sm-12 no-padding">
        <h4>Pesquisa:</h4>
        <br>
        <div class="form-group col-sm-3">
            <select name="select" [(ngModel)]="dispensaInegibilidadeFiltro.statusProposta" class="form-control">
                <option *ngFor="let item of listaStatus" [value]="item.value">{{item.label}}</option>
                <hr>
                <option value="">Todos</option>
            </select>
        </div>
        <div class="form-group col-sm-7">
            <input class="form-control" placeholder="Título" [(ngModel)]="dispensaInegibilidadeFiltro.titulo">
        </div>
        <div class="col-sm-2">
            <button class="btn btn-primary btn-block" (click)="buscarPropostas()">Pesquisar</button>
            <div class="checkbox" style="margin-top: 8px;">
                <label class="checkbox-inline">
                    <input type="checkbox" [(ngModel)]="manterFiltrosSelecionados" name="manterFiltrosSelecionados"
                        (ngModelChange)="alterarManterFiltrosSelecionados($event)">
                    Manter filtros selecionados
                </label>
            </div>
        </div>
    </div>

    <div class="col-sm-12 no-padding">
        <hr>
    </div>

    <div class="col-sm-12" *ngIf="listaParcerias">

        <h3 *ngIf="listaParcerias.length != 0" class="box-title">Propostas encontradas:</h3>
        <h3 *ngIf="listaParcerias.length == 0" class="box-title">Nenhuma proposta encontrada.</h3>

        <table class="table table-hover" *ngIf="listaParcerias.length != 0">
            <tbody>
                <tr>
                    <th>Entidade</th>
                    <th>Título</th>
                    <th>Status</th>
                    <th>Valor do projeto</th>
                    <th class="text-center" style="min-width: 105px;">Ações</th>
                </tr>

                <tr *ngFor="let prop of listaParcerias">
                    <td>{{ prop.entidadeConcedente.nome }}</td>
                    <td>{{ prop.titulo }}</td>
                    <td>{{ exibirStatus(prop.statusProposta)}}</td>
                    <td>{{ prop?.planoTrabalho[0]?.et2Valor | currency: 'BRL':'symbol-narrow':'1.2-2' }}</td>

                    <td class="text-center">
                        <span class="badge bg-green cursor" (click)="gotoAvaliacao(prop)" pTooltip="Avaliar proposta"
                            tooltipPosition="top"><i class="fa fa-check"></i></span>
                        <span class="badge bg-blue cursor" (click)="submeterProposta(prop)" pTooltip="Submeter proposta"
                            tooltipPosition="top"><i class="fas fa-arrow-right"></i></span>
                        <span class="badge bg-blue cursor" (click)="gotoEditar(prop.id)"
                                    pTooltip="Editar proposta" tooltipPosition="top"><i class="fa fa-pen"></i></span>
                        <span class="badge bg-red cursor" (click)="confirmarExclusao(prop)" pTooltip="Excluir proposta"
                            tooltipPosition="top"><i class="fa fa-trash"></i></span>

                    </td>
                </tr>
            </tbody>
        </table>

        <pagination *ngIf="listaParcerias.length != 0" [page]="page" (paginationEvent)=changePage($event)>
        </pagination>
    </div>

</div>
